import { CommonModule } from "@angular/common";
import { FormBuilder, ReactiveFormsModule } from "@angular/forms";

import { Component, inject, signal } from "@angular/core";
import { TicketService } from "../_services";

@Component({
  imports: [CommonModule, ReactiveFormsModule],
  selector: "hawk-ticket-fixer",
  templateUrl: "./ticket-fixer.component.html",
  styleUrls: ["./ticket-fixer.component.scss"],
  host: {
    class: "app-page",
  },
})
export class TicketFixerComponent {
  private fb = inject(FormBuilder);
  private ticketService = inject(TicketService);
  protected form = this.fb.group({
    importfile: this.fb.control({ value: "", disabled: false }),
  });

  protected status = signal<string>("new");
  protected errors = signal<string[]>([]);
  protected errorText = signal<string>("");

  public onFileChange(event) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.form.setValue({
        importfile: file,
      });
    }
  }

  public onSubmit() {
    const formData = new FormData();
    formData.append("file", this.form.get("importfile").value);
    this.status.set("running");

    this.ticketService.ticketFixerImport(formData).subscribe({
      next: (res) => {
        this.status.set("done");
        this.errors.set(res.errors || []);
        this.errorText.set(res.errorText || "");
      },
      error: (err) => {
        console.error(err);
        this.status.set("error");
        this.errors.set([]);
        this.errorText.set("es ist etwas schief gegangen.");
      },
    });
  }
}
